import { LoggingService } from '@instinet-analytics/core-lib';
import IndigoServiceClient from 'communication/IndigoServiceClient';
import { buildLogger, Logger } from '@instinet-analytics/core-lib';
import { ApiRequestOptions } from 'communication/ApiCallInfo';
import IndigoApiError from 'communication/IndigoApiError';

export interface OrderValidationApiOptions {
    loggingService: LoggingService;
    indigoServiceClient: IndigoServiceClient;
}

export class OrderValidationApi {
    private indigoServiceClient: IndigoServiceClient;
    private logger: Logger;

    public constructor(options: OrderValidationApiOptions) {
        this.indigoServiceClient = options.indigoServiceClient;
        this.logger = buildLogger('IndigoApi', options.loggingService);
    }

    public async validateOrderIds(
        orderIds: string[],
        options: ApiRequestOptions
    ): Promise<string[]> {
        const queryParameters = {
            orderIds: orderIds.join(','),
        };
        const url = 'order/validateOrderIds';

        return await IndigoApiError.runHandlingErrorsAsync(
            `Validate Order`,
            async () => {
                return await this.indigoServiceClient.get<string[]>(
                    url,
                    options,
                    queryParameters
                );
            }
        );
    }
}
